import styled from 'styled-components';

export const Wrapper = styled.div<{
  position: { x: number; y: number };
  transform: { x: boolean; y: boolean };
}>`
  position: fixed;
  display: flex;
  flex-direction: column;
  min-width: 110px;
  background: ${({ theme }) => theme.color.ui5};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  overflow: hidden;
  z-index: 10000;
  padding: ${({ theme }) => theme.dist.xxs};

  left: ${({ position }) => `${position.x}px`};
  top: ${({ position }) => `${position.y}px`};
  transform: ${({ transform }) =>
    `translate(${transform.x ? '-100%' : '0'}, ${transform.y ? '-100%' : '0'})`};
`;

export const Label = styled.div<{
  disabled: boolean;
}>`
  font-family: ${({ theme }) => theme.font.t2.fontFamily};
  font-weight: ${({ theme }) => theme.font.t2.fontWeight};
  font-size: ${({ theme }) => theme.font.t2.fontSize};
  padding: ${({ theme }) => theme.dist.xxs};
  border-top: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled, theme }) => (disabled ? theme.color.ui4 : theme.color.ui2)};
  position:relative;
  &:first-child {
    border-top: 0;
  }
  > span {
    pointer-events: none;
  }
  &:hover {
    color: ${({ theme, disabled }) => (disabled ? theme.color.ui4 : theme.color.ui5)};
    &:before {
      content: '';
      position: absolute;
      top: 0px;
      left: -10px;
      right: -10px;
      bottom: 0px;
      background: linear-gradient(90deg, transparent 0%, ${({ theme, disabled }) =>
        disabled ? 'transparent' : theme.color.s2} 10%, ${({ theme, disabled }) =>
  disabled ? 'transparent' : theme.color.s2} 100%);
      z-index: -1;
    }
`;
